import { event } from '@uhg-abyss/web/tools/event';
import { adobeTags } from './tags/adobe/index';

export const ADOBE_ANALYTICS_ID = 'adobe-analytics-communityconnector';

export const registerEvents = (metaData) => {
  event.listener({
    id: ADOBE_ANALYTICS_ID,
    trigger: (tag) => {
      if (typeof window !== 'undefined') {
        const dataLayer = ((window as any).adobeDataLayer =
          (window as any).adobeDataLayer || []);
        dataLayer.push(tag);
      }
    },
    events: adobeTags,
    metadata: metaData,
  });
};
